

























































































import {
  Prop,
  Emit,
  Component,
  Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import TransactionService from '@/services/TransactionService';

const Dialog = namespace('Dialog');
const transactionService = new TransactionService();

@Component
// eslint-disable-next-line max-len
export default class QrcodeGenerateDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public amount: number = 0;

  public qrcode: string = '';

  public loading: boolean = false;

  @Dialog.State
  public dialogData!: any;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  async requestQrcode() {
    try {
      const requestData = {
        amount: this.amount,
        accountNumber: this.dialogData.bank,
      };
      const { data } = await transactionService.getDepositQrCode(requestData);
      this.qrcode = data.qrcode;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: false });
    }
  }
}
